<template>
  <div>
    <div class="row m-0 v-clean pt-2 pb-2">
      <div class="col-md-12 pt-0 pb-0">
        <label-required-field class="m-0" label="SELECIONE O SERVIÇO" />
        <v-select
          :items="services"
          dense
          label=""
          outlined
          hide-details
          return-object
          :item-text="
            (item) => {
              return ` 
            ${item.description} 
            - CATEGORIA DO FINANCEIRO (${
              item.finance_configuration_category_name
                ? item.finance_configuration_category_name
                : 'NÃO INFORMADO'
            })`;
            }
          "
          @change="handleChangeServiceId"
        />
      </div>
      <div v-if="service" class="col-md-4 pt-0 pb-0">
        <label class="m-0">TIPO DE COBRANÇA</label>
        <v-text-field-default
          type="text"
          label=""
          disabled
          :value="service.service_charge_type_name"
        />
      </div>
      <div v-if="service" class="col-md-8 pt-0 pb-0">
        <label class="m-0">DESCRIÇÃO</label>
        <v-text-field-default
          type="text"
          label=""
          disabled
          :value="service.description"
        />
      </div>
      <div
        v-if="service && permission('read', 'financial')"
        class="col-md-12 pt-0 pb-0"
      >
        <label class="m-0">CATEGORIA DO FINANCEIRO</label>
        <v-text-field-default
          type="text"
          label=""
          disabled
          :value="
            service.finance_configuration_category_name
              ? service.finance_configuration_category_name
              : 'NÃO INFORMADO'
          "
        />
      </div>
    </div>
    <div v-if="service" class="row m-0 v-clean mt-2 pb-2">
      <div class="col-md-6 pt-0 pb-0">
        <label-required-field class="m-0" label="QUANTIDADE" />
        <v-text-field-default type="number" label="" v-model="quantity" />
      </div>
      <div class="col-md-6 pt-0 pb-0">
        <label-required-field class="m-0" label="DATA DO SERVIÇO" />
        <v-text-field-default type="date" label="" v-model="date" />
      </div>
    </div>
    <div v-if="service" class="row m-0 v-clean mt-2 pb-2">
      <div class="col-md-12 pt-0 pb-0">
        <label-required-field
          class="m-0"
          label="GERAR MAIS DE UM REGISTRO COM AS MESMAS INFORMAÇÕES?"
        />
        <v-select
          :items="[
            { value: 'NAO_SE_REPETE', text: 'NÃO' },
            { value: 'MAIS_DE_UMA_VEZ', text: 'SIM' },
          ]"
          dense
          label=""
          outlined
          hide-details
          item-value="value"
          item-text="text"
          v-model="repeat"
          @change="handleChangeRepeat"
        />
      </div>
      <div class="col-md-6 pt-0 pb-0" v-if="repeat == 'MAIS_DE_UMA_VEZ'">
        <label-required-field class="m-0" label="PERIODICIDADE" />
        <v-select
          :items="[
            { value: 'SEMANAL', text: 'SEMANAL' },
            { value: 'QUINZENAL', text: 'QUINZENAL' },
            { value: 'MENSAL', text: 'MENSAL' },
            { value: 'BIMESTRAL', text: 'BIMESTRAL' },
            { value: 'TRIMESTRAL', text: 'TRIMESTRAL' },
            { value: 'SEMESTRAL', text: 'SEMESTRAL' },
            { value: 'ANUAL', text: 'ANUAL' },
          ]"
          dense
          label=""
          outlined
          hide-details
          item-value="value"
          item-text="text"
          v-model="periodicity"
        />
      </div>
      <div v-if="repeat == 'MAIS_DE_UMA_VEZ'" class="col-md-6 pt-0 pb-0">
        <label-required-field class="m-0" label="QUANTAS VEZES" />
        <v-text-field-default type="number" label="" v-model="how_many_times" />
      </div>
      <div v-if="repeat == 'MAIS_DE_UMA_VEZ'" class="col-md-12">
        <p class="v-warning m-0 p-2 worksansr text-twelve">
          SERÁ GERADO OUTROS REGISTROS COM A MESMAS INFORMAÇÕES, MUDANDO APENAS
          A DATA DO SERVIÇO DE ACORDO COM A PERIODICIDADE.
        </p>
        <p class="v-warning mt-1 m-0 p-2 worksansr text-fourteen">
          APÓS GERAR, CASO FOR QUERER EDITAR OU EXCLUIR, TERÁ QUE FAZER
          LANÇAMENTO POR LANÇAMENTO.
        </p>
      </div>
    </div>
    <div v-if="service" class="row m-0 v-clean mt-2">
      <div class="col-md-12 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
      <div class="col-md-12 pt-0 text-right">
        <v-btn-save
          :disabled="loading"
          :loading="loading"
          text="SALVAR"
          @click="execute"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";

import VBtnSave from "../../../Components/VBtnSave.vue";

import LabelRequiredField from "../../../Components/LabelRequiredField.vue";

import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";

import { formatPrice } from "../../../../lib/format";

import permission from "../../../../lib/permission";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import moment from "moment";

export default {
  name: "NewService",

  components: {
    ErrorsMessages,
    VBtnSave,
    LabelRequiredField,
    VTextFieldDefault,
  },

  props: {
    resident: Object,
  },

  data() {
    return {
      service_id: "",

      repeat: "NAO_SE_REPETE",
      periodicity: "MENSAL",
      how_many_times: 1,

      service: null,

      quantity: 1,
      date: moment().format("YYYY-MM-DD"),

      services: [],

      loading: false,

      errors: [],
    };
  },

  created() {
    this.getServices();
  },

  methods: {
    permission,
    formatPrice,
    moment,

    handleChangeServiceId(service) {
      if (service) {
        let { id } = service;

        this.service_id = id;
        this.service = service;
      } else {
        this.service_id = "";
        this.service = null;
      }
    },

    handleChangeRepeat() {
      this.how_many_times = 1;
    },

    async getServices() {
      try {
        const response = await api.get("/rest-home/service/paginate");

        const { error, errors, services } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.services = services;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async execute() {
      try {
        this.loading = true;

        const {
          service_id,
          quantity,
          date,
          resident,
          repeat,
          periodicity,
          how_many_times,
        } = this;

        let params = {
          resident_id: resident.id,
          service_id,
          quantity,
          date,
          repeat,
          periodicity,
          how_many_times,
        };

        const response = await api.post("/rest-home/resident/service", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("create");
          toast(message, "success");
          this.$emit("success");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
